// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { implicitReturnType } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    privateEdgePostAuthApiKeyLogin (params?: {}): Promise<implicitReturnType>;
    privateEdgePostAuthWalletLogin (params?: {}): Promise<implicitReturnType>;
    publicMarketPostFullV1Instrument (params?: {}): Promise<implicitReturnType>;
    publicMarketPostFullV1AllInstruments (params?: {}): Promise<implicitReturnType>;
    publicMarketPostFullV1Instruments (params?: {}): Promise<implicitReturnType>;
    publicMarketPostFullV1Currency (params?: {}): Promise<implicitReturnType>;
    publicMarketPostFullV1MarginRules (params?: {}): Promise<implicitReturnType>;
    publicMarketPostFullV1Mini (params?: {}): Promise<implicitReturnType>;
    publicMarketPostFullV1Ticker (params?: {}): Promise<implicitReturnType>;
    publicMarketPostFullV1Book (params?: {}): Promise<implicitReturnType>;
    publicMarketPostFullV1Trade (params?: {}): Promise<implicitReturnType>;
    publicMarketPostFullV1TradeHistory (params?: {}): Promise<implicitReturnType>;
    publicMarketPostFullV1Kline (params?: {}): Promise<implicitReturnType>;
    publicMarketPostFullV1Funding (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1CreateOrder (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1CancelOrder (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1CancelOnDisconnect (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1CancelAllOrders (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1Order (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1OrderHistory (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1OpenOrders (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1FillHistory (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1Positions (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1FundingPaymentHistory (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1GetSubAccounts (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1AccountSummary (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1AccountHistory (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1AggregatedAccountSummary (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1FundingAccountSummary (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1Transfer (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1DepositHistory (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1TransferHistory (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1Withdrawal (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1WithdrawalHistory (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1AddPositionMargin (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1GetPositionMarginLimits (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1SetPositionConfig (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1SetInitialLeverage (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1GetAllInitialLeverage (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1SetDeriskMmRatio (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1VaultBurnTokens (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1VaultInvest (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1VaultInvestorSummary (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1VaultRedeem (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1VaultRedeemCancel (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1VaultViewRedemptionQueue (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1VaultManagerInvestorHistory (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1AuthorizeBuilder (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1GetAuthorizedBuilders (params?: {}): Promise<implicitReturnType>;
    privateTradingPostFullV1BuilderFillHistory (params?: {}): Promise<implicitReturnType>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
